import { IProductFull } from "../../Utils/types";
import { shopApi } from "../api";
import { ThunkAction } from "redux-thunk";
import { AppState, AppActions } from "../Store/store";
import { setPagination } from "./paginationReducer";

interface IProductsState {
  productsStatus: 'loading' | 'loaded',
  products: [],
  currentProduct: IProductFull
}
const productsState: IProductsState = {
  productsStatus: 'loading',
  products: [],
  currentProduct: {
    id: 0,
    name: '',
    categoryId: 0,
    photourl: {
      huge: '',
      small: ''
    },
    price: 0,
    tags: []
  }
}

// Action types
export const SET_PRODUCT_STATUS = 'products/SET_PRODUCT_STATUS';
export const SET_PRODUCTS = 'products/SET_PRODUCTS';
export const APPLY_UPDATE_PRODUCT = 'products/APPLY_UPDATE_PRODUCT';
export const UPDATE_PRODUCT = 'products/UPDATE_PRODUCT';
export const UPDATE_PRODUCT_PHOTO = 'products/UPDATE_PRODUCT_PHOTO';
export const SET_PRODUCT_INFO = 'products/SET_PRODUCT_INFO';
export const REMOVE_PRODUCT = 'products/REMOVE_PRODUCT';

// Selectors
export const productsSelector = (state: any) => state.products.products;
export const currentProductSelector = (state: any) => state.products.currentProduct;
export const productsStatusSelector = (state: any) => state.products.productsStatus;

// Reducer
export function productsReducer(state: IProductsState = productsState, action: any) {
  switch (action.type) {
    case UPDATE_PRODUCT_PHOTO: {
      return {
        ...state,
        currentProduct: {
          ...state.currentProduct,
          photourl: action.payload
        }
      }
    }

    case SET_PRODUCT_STATUS: {
      return {
        ...state,
        productsStatus: action.payload
      }
    }

    case SET_PRODUCTS: {
      return {
        ...state,
        products: [...action.payload]
      }
    }

    case UPDATE_PRODUCT: {
      return {
        ...state,
        currentProduct: {
          ...state.currentProduct,
          [action.name]: action.value
        }
      }
    }

    case SET_PRODUCT_INFO: {
      return {
        ...state,
        currentProduct: { ...action.payload }
      }
    }

    case APPLY_UPDATE_PRODUCT: {
      let newArray: any = [...state.products];
      const applyIndex = newArray.findIndex((item: any) => {
        return item.id === +action.payload.id;
      });
      newArray[applyIndex] = action.payload;

      return {
        ...state,
        products: newArray,
        currentProduct: { ...productsState.currentProduct }
      }
    }

    case REMOVE_PRODUCT: {
      let newArray: any[] = [...state.products];
      const id = newArray.findIndex((item) => item.id === action.payload);
      newArray.splice(id, 1);

      return {
        ...state,
        products: newArray
      }
    }

    default: {
      return state;
    }
  }
}

// Actions
interface UpdateProductPhotoType {
  type: typeof UPDATE_PRODUCT_PHOTO,
  payload: any
}
export function updateProductPhoto(file: any, id: number, mod?: boolean): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any, getState: any) => {
    const response = await shopApi.uploadPhoto(file, id, mod);
    dispatch({
      type: UPDATE_PRODUCT_PHOTO,
      payload: response.photo
    });
  }
}

interface GetProductsType {
  type: typeof SET_PRODUCTS,
  payload: []
}
export function getProducts(page: number, pageSize: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch, getState) => {
    dispatch(setProductStatus('loading'));
    const products = await shopApi.getProducts(page, pageSize);
    dispatch({
      type: SET_PRODUCTS,
      payload: products.products
    });
    dispatch(setPagination(products.page, products.elsePages))
    dispatch(setProductStatus('loaded'));
  }
}

interface SetProductStatusType {
  type: typeof SET_PRODUCT_STATUS,
  payload: string
}
export function setProductStatus(payload: string): SetProductStatusType {
  return {
    type: SET_PRODUCT_STATUS,
    payload
  }
}

interface GetProductInfoType {
  type: typeof SET_PRODUCT_INFO,
  payload: IProductFull
}
export function getProductInfo(id: number) {
  return async (dispatch: any) => {
    const response = await shopApi.getProduct(id);
    dispatch({
      type: SET_PRODUCT_INFO,
      payload: response.product
    });
  }
}

interface UpdateProductType {
  type: typeof UPDATE_PRODUCT,
  name: string,
  value: string
}
export function updateProduct(name: string, value: any): UpdateProductType {
  return {
    type: UPDATE_PRODUCT,
    name,
    value
  };
}

interface ApplyUpdateProductType {
  type: typeof APPLY_UPDATE_PRODUCT,
  payload: IProductFull
}
export function applyUpdateProduct(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any, getState: any) => {
    const data = currentProductSelector(getState());

    await shopApi.applyUpdateProduct(data);
    dispatch({
      type: APPLY_UPDATE_PRODUCT,
      payload: data
    });
  }
}

interface RemoveProductType {
  type: typeof REMOVE_PRODUCT,
  payload: number
}
export function removeProduct(id: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any, getState: any) => {
    await shopApi.removeProduct(id);
    dispatch({
      type: REMOVE_PRODUCT,
      payload: id
    });
  }
}

export type ProductsActions =
  RemoveProductType
  | ApplyUpdateProductType
  | UpdateProductType
  | GetProductInfoType
  | UpdateProductPhotoType
  | GetProductsType
  | SetProductStatusType;